module.exports = __webpack_public_path__ + "media/7_3.9cbdb161.wav";